// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import { AddressFieldsFragmentDoc } from './addresses.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LodgingFieldsFragment = { __typename?: 'Lodging', id: string, name: string, description: string, type: Types.LodgingType, type_name: string, capacity: number, cover_image: string, is_single_use?: boolean | null, created_at: number, updated_at: number, outfitter: { __typename?: 'Outfitter', id: string, slug: string }, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null, location?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state: string, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null } | null };

export type LodgingsByOwnerQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type LodgingsByOwnerQuery = { __typename?: 'Query', lodgingsByOwner: Array<{ __typename?: 'Lodging', id: string, name: string, description: string, type: Types.LodgingType, type_name: string, capacity: number, cover_image: string, is_single_use?: boolean | null, created_at: number, updated_at: number, outfitter: { __typename?: 'Outfitter', id: string, slug: string }, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null, location?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state: string, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null } | null }> };

export type LodgingsByOutfitterQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
}>;


export type LodgingsByOutfitterQuery = { __typename?: 'Query', lodgingsByOutfitter: Array<{ __typename?: 'Lodging', id: string, name: string, description: string, type: Types.LodgingType, type_name: string, capacity: number, cover_image: string, is_single_use?: boolean | null, created_at: number, updated_at: number, outfitter: { __typename?: 'Outfitter', id: string, slug: string }, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null, location?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state: string, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null } | null }> };

export type LodgingQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type LodgingQuery = { __typename?: 'Query', lodging: { __typename?: 'Lodging', id: string, name: string, description: string, type: Types.LodgingType, type_name: string, capacity: number, cover_image: string, is_single_use?: boolean | null, created_at: number, updated_at: number, outfitter: { __typename?: 'Outfitter', id: string, slug: string }, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null, location?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state: string, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null } | null } };

export type CreateLodgingMutationVariables = Types.Exact<{
  data: Types.CreateLodgingInput;
}>;


export type CreateLodgingMutation = { __typename?: 'Mutation', createLodging: { __typename?: 'Lodging', id: string, name: string, description: string, type: Types.LodgingType, type_name: string, capacity: number, cover_image: string, is_single_use?: boolean | null, created_at: number, updated_at: number, outfitter: { __typename?: 'Outfitter', id: string, slug: string }, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null, location?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state: string, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null } | null } };

export type UpdateLodgingMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  data: Types.UpdateLodgingInput;
}>;


export type UpdateLodgingMutation = { __typename?: 'Mutation', updateLodging: { __typename?: 'Lodging', id: string, name: string, description: string, type: Types.LodgingType, type_name: string, capacity: number, cover_image: string, is_single_use?: boolean | null, created_at: number, updated_at: number, outfitter: { __typename?: 'Outfitter', id: string, slug: string }, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null, location?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state: string, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null } | null } };

export type DeleteLodgingMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteLodgingMutation = { __typename?: 'Mutation', deleteLodging?: any | null };

export const LodgingFieldsFragmentDoc = gql`
    fragment LodgingFields on Lodging {
  id
  name
  description
  type
  type_name
  capacity
  outfitter {
    id
    slug
  }
  images {
    url
    description
  }
  location {
    ...AddressFields
  }
  cover_image
  is_single_use
  created_at
  updated_at
}
    ${AddressFieldsFragmentDoc}`;
export const LodgingsByOwnerDocument = gql`
    query lodgingsByOwner($id: ID!) {
  lodgingsByOwner(ownerId: $id) {
    ...LodgingFields
  }
}
    ${LodgingFieldsFragmentDoc}`;

/**
 * __useLodgingsByOwnerQuery__
 *
 * To run a query within a React component, call `useLodgingsByOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useLodgingsByOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLodgingsByOwnerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLodgingsByOwnerQuery(baseOptions: Apollo.QueryHookOptions<LodgingsByOwnerQuery, LodgingsByOwnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LodgingsByOwnerQuery, LodgingsByOwnerQueryVariables>(LodgingsByOwnerDocument, options);
      }
export function useLodgingsByOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LodgingsByOwnerQuery, LodgingsByOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LodgingsByOwnerQuery, LodgingsByOwnerQueryVariables>(LodgingsByOwnerDocument, options);
        }
export type LodgingsByOwnerQueryHookResult = ReturnType<typeof useLodgingsByOwnerQuery>;
export type LodgingsByOwnerLazyQueryHookResult = ReturnType<typeof useLodgingsByOwnerLazyQuery>;
export type LodgingsByOwnerQueryResult = Apollo.QueryResult<LodgingsByOwnerQuery, LodgingsByOwnerQueryVariables>;
export const LodgingsByOutfitterDocument = gql`
    query lodgingsByOutfitter($outfitterId: ID!) {
  lodgingsByOutfitter(outfitterId: $outfitterId) {
    ...LodgingFields
  }
}
    ${LodgingFieldsFragmentDoc}`;

/**
 * __useLodgingsByOutfitterQuery__
 *
 * To run a query within a React component, call `useLodgingsByOutfitterQuery` and pass it any options that fit your needs.
 * When your component renders, `useLodgingsByOutfitterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLodgingsByOutfitterQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *   },
 * });
 */
export function useLodgingsByOutfitterQuery(baseOptions: Apollo.QueryHookOptions<LodgingsByOutfitterQuery, LodgingsByOutfitterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LodgingsByOutfitterQuery, LodgingsByOutfitterQueryVariables>(LodgingsByOutfitterDocument, options);
      }
export function useLodgingsByOutfitterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LodgingsByOutfitterQuery, LodgingsByOutfitterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LodgingsByOutfitterQuery, LodgingsByOutfitterQueryVariables>(LodgingsByOutfitterDocument, options);
        }
export type LodgingsByOutfitterQueryHookResult = ReturnType<typeof useLodgingsByOutfitterQuery>;
export type LodgingsByOutfitterLazyQueryHookResult = ReturnType<typeof useLodgingsByOutfitterLazyQuery>;
export type LodgingsByOutfitterQueryResult = Apollo.QueryResult<LodgingsByOutfitterQuery, LodgingsByOutfitterQueryVariables>;
export const LodgingDocument = gql`
    query lodging($id: ID!) {
  lodging(id: $id) {
    ...LodgingFields
  }
}
    ${LodgingFieldsFragmentDoc}`;

/**
 * __useLodgingQuery__
 *
 * To run a query within a React component, call `useLodgingQuery` and pass it any options that fit your needs.
 * When your component renders, `useLodgingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLodgingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLodgingQuery(baseOptions: Apollo.QueryHookOptions<LodgingQuery, LodgingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LodgingQuery, LodgingQueryVariables>(LodgingDocument, options);
      }
export function useLodgingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LodgingQuery, LodgingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LodgingQuery, LodgingQueryVariables>(LodgingDocument, options);
        }
export type LodgingQueryHookResult = ReturnType<typeof useLodgingQuery>;
export type LodgingLazyQueryHookResult = ReturnType<typeof useLodgingLazyQuery>;
export type LodgingQueryResult = Apollo.QueryResult<LodgingQuery, LodgingQueryVariables>;
export const CreateLodgingDocument = gql`
    mutation createLodging($data: CreateLodgingInput!) {
  createLodging(data: $data) {
    ...LodgingFields
  }
}
    ${LodgingFieldsFragmentDoc}`;
export type CreateLodgingMutationFn = Apollo.MutationFunction<CreateLodgingMutation, CreateLodgingMutationVariables>;

/**
 * __useCreateLodgingMutation__
 *
 * To run a mutation, you first call `useCreateLodgingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLodgingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLodgingMutation, { data, loading, error }] = useCreateLodgingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLodgingMutation(baseOptions?: Apollo.MutationHookOptions<CreateLodgingMutation, CreateLodgingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLodgingMutation, CreateLodgingMutationVariables>(CreateLodgingDocument, options);
      }
export type CreateLodgingMutationHookResult = ReturnType<typeof useCreateLodgingMutation>;
export type CreateLodgingMutationResult = Apollo.MutationResult<CreateLodgingMutation>;
export type CreateLodgingMutationOptions = Apollo.BaseMutationOptions<CreateLodgingMutation, CreateLodgingMutationVariables>;
export const UpdateLodgingDocument = gql`
    mutation updateLodging($id: ID!, $data: UpdateLodgingInput!) {
  updateLodging(id: $id, data: $data) {
    ...LodgingFields
  }
}
    ${LodgingFieldsFragmentDoc}`;
export type UpdateLodgingMutationFn = Apollo.MutationFunction<UpdateLodgingMutation, UpdateLodgingMutationVariables>;

/**
 * __useUpdateLodgingMutation__
 *
 * To run a mutation, you first call `useUpdateLodgingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLodgingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLodgingMutation, { data, loading, error }] = useUpdateLodgingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLodgingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLodgingMutation, UpdateLodgingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLodgingMutation, UpdateLodgingMutationVariables>(UpdateLodgingDocument, options);
      }
export type UpdateLodgingMutationHookResult = ReturnType<typeof useUpdateLodgingMutation>;
export type UpdateLodgingMutationResult = Apollo.MutationResult<UpdateLodgingMutation>;
export type UpdateLodgingMutationOptions = Apollo.BaseMutationOptions<UpdateLodgingMutation, UpdateLodgingMutationVariables>;
export const DeleteLodgingDocument = gql`
    mutation deleteLodging($id: ID!) {
  deleteLodging(id: $id)
}
    `;
export type DeleteLodgingMutationFn = Apollo.MutationFunction<DeleteLodgingMutation, DeleteLodgingMutationVariables>;

/**
 * __useDeleteLodgingMutation__
 *
 * To run a mutation, you first call `useDeleteLodgingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLodgingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLodgingMutation, { data, loading, error }] = useDeleteLodgingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLodgingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLodgingMutation, DeleteLodgingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLodgingMutation, DeleteLodgingMutationVariables>(DeleteLodgingDocument, options);
      }
export type DeleteLodgingMutationHookResult = ReturnType<typeof useDeleteLodgingMutation>;
export type DeleteLodgingMutationResult = Apollo.MutationResult<DeleteLodgingMutation>;
export type DeleteLodgingMutationOptions = Apollo.BaseMutationOptions<DeleteLodgingMutation, DeleteLodgingMutationVariables>;